module.exports = __webpack_public_path__ + "static/media/informationIcon-w.deeea481.svg";